import { TrackedShipmentRouteSegment } from '@project44-models/shipment-entity';

export type Modes =
  | 'OCEAN'
  | 'TRUCKLOAD'
  | 'LTL'
  | 'PARCEL'
  | 'RAIL'
  | 'AIR'
  | 'BARGE';

export const enum MARKER_ICON {
  PAST_EVENT = 'complete-stop',
  FUTURE_EVENT = 'final-stop',
}

export const MODE_ICON_MAP: Record<Modes, string> = {
  OCEAN: 'boat',
  TRUCKLOAD: 'truck',
  LTL: 'ltl',
  PARCEL: 'parcel',
  RAIL: 'rail',
  AIR: 'air',
  BARGE: 'boat',
};

export const getSegmentIcon = (routeSegment?: TrackedShipmentRouteSegment) => {
  return routeSegment
    ? MODE_ICON_MAP[routeSegment?.transportationMode as Modes] || 'unknown'
    : 'unknown';
};
